import { createSlice } from '@reduxjs/toolkit';
import { loanApi } from '../../services/loanApi';

const initialState = {
  loanRequests: [],
  loading: false,
  error: null,
  filters: {
    status: '',
    loanType: '',
    search: '',
  },
  pagination: {
    currentPage: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  stats: {
    totalRequests: 0,
    pendingRequests: 0,
    approvedRequests: 0,
    rejectedRequests: 0,
    activeLoans: 0,
    totalLoanAmount: 0,
  },
  selectedLoan: null,
};

const loanSlice = createSlice({
  name: 'loan',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.currentPage = 1;
    },
    clearFilters: (state) => {
      state.filters = {
        status: '',
        loanType: '',
        search: '',
      };
      state.pagination.currentPage = 1;
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setStats: (state, action) => {
      state.stats = action.payload;
    },
    setSelectedLoan: (state, action) => {
      state.selectedLoan = action.payload;
    },
    clearSelectedLoan: (state) => {
      state.selectedLoan = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get loan requests
      .addMatcher(
        loanApi.endpoints.getLoanRequests.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        loanApi.endpoints.getLoanRequests.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.loanRequests = action.payload.data;
          state.pagination = action.payload.pagination;
          state.stats = action.payload.stats;
        }
      )
      .addMatcher(
        loanApi.endpoints.getLoanRequests.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      )
      // Get single loan request
      .addMatcher(
        loanApi.endpoints.getLoanRequest.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        loanApi.endpoints.getLoanRequest.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.selectedLoan = action.payload.data;
        }
      )
      .addMatcher(
        loanApi.endpoints.getLoanRequest.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );
  },
});

export const {
  setFilters,
  clearFilters,
  setCurrentPage,
  setPagination,
  setStats,
  setSelectedLoan,
  clearSelectedLoan,
  setLoading,
  setError,
} = loanSlice.actions;

export default loanSlice.reducer;